export default "__VITE_ASSET__CDVgsl5O__"